export default __webpack_public_path__ + "assets/2ca61b76e22053571dd8611e5aac4900.png";